
import * as storyblokRuntime$IeFTocEN_WZqt_6DfQ5YPdnwF9dEowxRUKwM3177Pic from '/codebuild/output/src3996917137/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$gRaYlAL_wic4xJOPUn2eTRhYbMK81Ec7MyQxlT4gRNU from '/codebuild/output/src3996917137/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$IeFTocEN_WZqt_6DfQ5YPdnwF9dEowxRUKwM3177Pic, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$gRaYlAL_wic4xJOPUn2eTRhYbMK81Ec7MyQxlT4gRNU, defaults: {} }
}
        